import { FC, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from 'react-oidc-context';

export const AuthCallback: FC = () => {
    const auth = useAuth();
    const navigate = useNavigate();

    useEffect(() => {
        if (auth) {
            // Check if we're in the callback phase and authentication is complete
            if (auth.isAuthenticated && !auth.isLoading) {
                // Authentication successful, navigate to organizations page
                navigate('/organizations');
            }
        }
    }, [auth, navigate]);

    // Show loading state while processing the authentication
    return (
        <div className="flex items-center justify-center min-h-screen bg-gray-100">
            <div className="bg-white p-8 rounded-lg shadow-md">
                <h2 className="text-xl font-semibold mb-4">Completing authentication...</h2>
                {!auth.isAuthenticated && !auth.isLoading && (
                    <p className="text-red-600">Authentication failed</p>
                )}
            </div>
        </div>
    );
}; 